import Col from 'react-bootstrap/Col';
import styles from './Product.module.scss';
import React, { FC } from 'react';
import { ActiveProductsModel } from '../../query/types';
import {generateImageUrl} from "../../../../utils/cdnService";
import classNames from 'classnames';

type Props = {
  product: ActiveProductsModel;
  columnWidth: number;
  onSelected: (product: any) => void;
  selectedTicket: { id: number };
};

const Product: FC<Props> = ({ product, columnWidth, onSelected, selectedTicket }) => {
  const withContrast = true;
  return (
    <Col
      sm={columnWidth}
      className={`${styles.ticketWrapper} ${selectedTicket.id === product.id ? styles.selected : ''}`}
      onClick={() => {
        localStorage.setItem('blue_price', JSON.stringify(product.price));
        onSelected(product);
      }}
    >
      <div style={{ position: 'relative' }}>
        {selectedTicket.id === product.id && (
          <div
            style={{
              position: 'absolute',
            }}
            className={styles.checkMark}
          >
            <i className="fa fa-check" aria-hidden="true"></i>
          </div>
        )}
        <div style={{ textAlign: 'center' }} className={`${selectedTicket.id === product.id ? styles.selected : styles.dimmed}`}>
          <img alt="url-img" src={`${generateImageUrl('gcore', 344, 165, product.asset.image)}`} />
        </div>
      </div>

      {product.asset && product.asset.translation && (
        <div style={{ textAlign: 'center' }}>
          <h3 className={selectedTicket.id === product.id ? '' : styles.dimmed} style={{ fontSize: '1.4em', fontWeight: 700 }}>
            <i style={{ marginRight: 10 }} className="fa fa-ticket" aria-hidden="true" />
            {product.asset.translation.title.split('für')[0]}für
          </h3>
          <p className={classNames(styles.price, { [styles.contrast]: withContrast })}>{product.asset.translation.title.split('für')[1]}</p>
          <p className={selectedTicket.id === product.id ? '' : styles.dimmed} style={{ fontSize: '0.8rem' }}>{product.asset.translation.price_text}</p>
        </div>
      )}
    </Col>
  );
};

export default Product;
